import { render, staticRenderFns } from "./NewAddressButton.vue?vue&type=template&id=5ab733dd&scoped=true&"
import script from "./NewAddressButton.vue?vue&type=script&lang=js&"
export * from "./NewAddressButton.vue?vue&type=script&lang=js&"
import style0 from "./NewAddressButton.vue?vue&type=style&index=0&id=5ab733dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab733dd",
  null
  
)

export default component.exports